import React from 'react'
import { ReactComponent as ActiveControl } from "../../../../../../assets/img/svg/ActiveControl.svg";
import { ReactComponent as InactiveControl } from "../../../../../../assets/img/svg/InactiveControl.svg";
import { endpoint } from "../../../common/constant";
import AButton from "../../../common/form-fields-mui/AButton";
import { fetchAllPromisedData } from "../../../common/utils/methods/commonMethods/utilityMethod";
import { ReactComponent as DeleteIcon } from "../../../../../../assets/img/svg/Delete.svg";
import {ReactComponent as EditIcon} from 'assets/img/svg/EditGryIcon.svg'
import {ReactComponent as BlackEditIcon} from 'assets/img/svg/EditBlackIcon.svg'

export const newRow = {
    financeInstitution: '',
    businessArea: { label: '', value: '' },
    merchantId: '',
    key: '',
    salt: '',
    status: 'ACTIVE'
};

export const statusDropdown = [
    { label: 'Active', value: 'ACTIVE' },
    { label: 'Inactive', value: 'INACTIVE' }
]
export const vendorTypeDropdown = [
    { label: 'Active', value: 'ACTIVE' },
    { label: 'Inactive', value: 'INACTIVE' }
]

export const StatusCellComponent = ({ value, handleChange = () => { }, showText=false }) => {

    return (
       value&& value.toUpperCase() === 'ACTIVE'
            ? <span><ActiveControl onClick={() => handleChange('INACTIVE')} /> {showText && "Active"} </span>
            : <span><InactiveControl onClick={() => handleChange('ACTIVE')} /> {showText && "Inactive"} </span>
    )

}

export const ActionsCellComponent = ({editPermission=true, deletePermission=true, mode, handleEditClick,handleDeleteClick, handleSaveClick, handleCancelClick, params , isSaveDisabled, cancelIcon = null,icon=false,deleteIcon=false,customEditIcon}) => {
    return (
        mode === 'view'
            ?<>{editPermission&&( icon?customEditIcon?
                <span className='cursor'><BlackEditIcon onClick={()=>{handleEditClick(params)}}/></span>
                :<span className='cursor'><EditIcon onClick={()=>{handleEditClick(params)}}/></span>:<AButton
                variant='primary_filled'
                onClick={() => handleEditClick(params)}
                size='xs'
                disabled={!!isSaveDisabled}
            >
                Edit
            </AButton>)}
            {deletePermission&&deleteIcon&&<DeleteIcon
                        className='ml-3 mr-1'
                        onClick={() => handleDeleteClick(params)}
                    >
                        Cancel
                    </DeleteIcon>}
            </>
            : <>
                <AButton
                    variant='primary_filled'
                    size='xs'
                    onClick={handleSaveClick}
                    disabled={isSaveDisabled}
                >
                    Save
                </AButton>

                {cancelIcon ? cancelIcon
                    : <DeleteIcon
                        className='ml-3 mr-1'
                        onClick={() => handleCancelClick(params)}
                    >
                        Cancel
                    </DeleteIcon>
                }
            </>
    )

}

export const getAllActiveBusinessArea = async () => {
    try {
        const resp = await fetchAllPromisedData(endpoint.businessArea.getAllActiveV2, true);
        if (resp?.code === 200) {
            return resp?.data?.map(bu => ({ ...bu, label: bu?.businessAreaDispValue, value: bu?.id }))
        }
        return [];
    } catch (err) {
        console.log(err);
    }
}